"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _DatePicker = _interopRequireDefault(require("../../../DatePicker"));
var _withLogic = _interopRequireDefault(require("../withLogic"));
var _excluded = ["form", "value", "name", "onBlur", "options"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DatePicker = function DatePicker(_ref) {
  var form = _ref.form,
    value = _ref.value,
    name = _ref.name,
    onBlur = _ref.onBlur,
    options = _ref.options,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_DatePicker["default"], _extends({
    onChange: function onChange(input) {
      return form.setFieldValue(name, (0, _format["default"])(input, 'yyyyMMdd'));
    },
    value: value && (0, _parse["default"])(value, 'yyyyMMdd', new Date())
  }, (0, _omit["default"])(rest, ['onChange', 'onBlur'])));
};
DatePicker.propTypes = {
  form: _propTypes["default"].object,
  name: _propTypes["default"].string,
  value: _propTypes["default"].element,
  onBlur: _propTypes["default"].func,
  options: _propTypes["default"].array,
  validateStatus: _propTypes["default"].string
};
var _default = (0, _withLogic["default"])(DatePicker);
exports["default"] = _default;